export function replaceImage(element, fallbackSource, replaceLink, placeholder) {
  placeholder = placeholder || '';
  var clone = element.clone();
  clone.attr('src', fallbackSource);

  if (placeholder.trim() !== '') {
    clone.attr('onerror', 'replaceImage($(this), \'' + placeholder + '\', \'' + replaceLink + '\');');
  }

  if (replaceLink === 'true') {
    element.closest('a').attr('href', fallbackSource);
  }

  element.replaceWith(clone);
}

window.replaceImage = replaceImage;
